import { getScribeHttpClients } from '@heidi/api/client';
import type { components } from '@heidi/schema/ml-scribe';
import { useQuery } from '@tanstack/react-query';

import { DOCUMENT_EXPORT_SUGGESTIONS_QUERY_KEY } from '../../contracts';

type DocumentExportSuggestionResponse =
  components['schemas']['DocumentExportSuggestionResponse'];

async function getDocumentExportSuggestions(
  sessionId: string,
  documentId: string
): Promise<DocumentExportSuggestionResponse> {
  const { data } =
    await getScribeHttpClients().scribeHttpV2.get<DocumentExportSuggestionResponse>(
      '/chat/document-export-suggestions',
      { params: { session_id: sessionId, document_id: documentId } }
    );
  return data;
}

export function useQueryDocumentExportSuggestions({
  sessionId,
  documentId,
  enabled,
}: {
  sessionId: string;
  documentId: string | null | undefined;
  enabled: boolean;
}) {
  return useQuery<DocumentExportSuggestionResponse>({
    queryKey: [DOCUMENT_EXPORT_SUGGESTIONS_QUERY_KEY, sessionId, documentId],
    queryFn: () => getDocumentExportSuggestions(sessionId, documentId as string),
    enabled,
    staleTime: Infinity,
  });
}
